import React from 'react'
import ArrowIcon from '../../elements/icons/ArrowIcon'
import TrashIcon from '../../elements/icons/TrashIcon'

const FeeCard = ({fee, openFee}) => {
  return (
    <div className='p-5 bg-gray-50'>
        <p>{fee.name}</p>
        <p className='text-xs truncate'>{fee.description}</p>

        <p className='text-xs text-gray-500 mt-[10px]'>Designated Account</p>
        {fee.feeAccount ? <p className='text-xs'>{fee.feeAccount.accountName} - {fee.feeAccount.accountNumber} ({fee.feeAccount.bankName})</p> 
        : 
        <p className='text-xs text-gray-400'>No designated account</p>}

        <div className="w-full mt-3 flex flex-row items-center justify-between">
          <p className='w-full pb-2 border-b text-xl mt-2 font-medium font-space-grotesk'>₦{(fee.amount/100).toLocaleString()}</p>

          {/* <div className='flex flex-row gap-x-[5px] mt-2'> */}
            {fee.active ? <span className='bg-green-500 bg-opacity-10 text-green-500 text-xs px-2 rounded py-1 font-medium'>Active</span>
            :
            <span className='bg-gray-50 text-gray-400 px-2 rounded text-xs font-outfit py-1'>Inactive</span>
            }

            {/* {fee.creditToStudent && <span className='bg-vcm-light-purple bg-opacity-30 text-vcm-purple text-xs px-2 rounded py-1 font-medium'>Credited to Student</span>} */}
          {/* </div> */}
        </div>
        <div className="w-full flex items-center justify-between mt-3">
            <button onClick={()=>{openFee()}} className='text-sm flex flex-row items-center gap-x-3 text-vcm-purple hover:text-gray-400 transition duration-200'>View/Edit Fee <ArrowIcon className={`w-5 h-5`} /></button> 

            <button className='p-1 rounded bg-transparent hover:bg-vcm-light-purple hover:bg-opacity-20 transition duration-200 text-gray-400 hover:text-vcm-purple'>
                <TrashIcon className={`w-5 h-5`} />
            </button>
        </div>

    </div>
  )
}

export default FeeCard